import { ProductFulfillmentCategories, DeliveryStatus, ProgramTypeVariants } from "../../constants.js";
import { REPLACEMENT_TYPE, ATTRIBUTE_HIDE_PRICE_RANGE_KEY, ATTRIBUTE_1_VALUE, ATTRIBUTE_BUNDLE } from "../normalizePCP/constants.js";
import { getInWareHouseChannelBadgeData as getInWareHouseChannelBadgeData$1, getDeliveryChannelBadgeData as getDeliveryChannelBadgeData$1, getProgramTypeAvailability as getProgramTypeAvailability$1, getInWarehouseAvailabilityText as getInWarehouseAvailabilityText$1, getFsaEligibility as getFsaEligibility$1, getChdiEligibility as getChdiEligibility$1, getColorSwatchesData as getColorSwatchesData$1, getCompareProductButtonData as getCompareProductButtonData$1, getReviewRatingData as getReviewRatingData$1, getImageUrlPCP as getImageUrlPCP$1, getPillBadges as getPillBadges$1, getProductDeliveryBadgeData as getProductDeliveryBadgeData$1, getProductFeaturesData as getProductFeaturesData$1, getProductActions as getProductActions$1 } from "../normalizePCP/lib.js";
import { PROGRAM_TYPES_PRICE_WAREHOUSE, PRODUCT_CLASS_TYPES } from "../../searchService/LucidWorks/constants.js";
import { isBD, isBC } from "../../../utils/businessType.lib.js";
import { hasMembershipId } from "../../../utils/index.js";
import { getSelectedWarehouseCatalog, selectByWarehouse } from "../../../utils/product.js";
import { getProductFullfillmentTexts } from "../../../components/Product/PriceTooltip/lib.js";
const programTypeToLowercase = (item) => {
  var _a;
  return (_a = item == null ? void 0 : item.programTypes) == null ? void 0 : _a.map((programType) => programType.toLowerCase());
};
const getInWarehouseAvailabilityText = (...args) => getInWarehouseAvailabilityText$1(...args);
const getProgramTypeAvailability = (...args) => getProgramTypeAvailability$1(...args);
const isProgramTypeExists = (item, pType) => {
  const toLowerCaseProgramTypeSet = new Set(
    programTypeToLowercase(item)
  );
  return toLowerCaseProgramTypeSet.has(pType.toLowerCase());
};
const hasInWarehouseStock = (inventoryData) => {
  return inventoryData == null ? void 0 : inventoryData.some((item) => {
    const { programTypes } = item;
    return getProgramTypeAvailability(
      (programTypes == null ? void 0 : programTypes["3rdPartyDelivery"]) || {}
    );
  });
};
const hasDeliveryViaInstacart = (item, inventoryData) => {
  return isProgramTypeExists(item, ProgramTypeVariants.THIRD_PARTY_DELIVERY) && hasInWarehouseStock(inventoryData);
};
const getDeliveryStatus = (catalogItem, bopiwWarehouseEnabled, wioWarehouseEnabled, inventoryData) => {
  const { isBuyable, startDate } = catalogItem;
  const deliveryStatus = getDeliveryChannelBadgeData$1(
    { isBuyable, startDate },
    bopiwWarehouseEnabled,
    wioWarehouseEnabled,
    inventoryData
  );
  if (deliveryStatus === DeliveryStatus.Unavailable && hasDeliveryViaInstacart(catalogItem, inventoryData))
    return DeliveryStatus.ViaInstacart;
  return deliveryStatus;
};
const getDeliveryChannelBadgeData = (catalogItem, bopiwWarehouseEnabled, wioWarehouseEnabled, inventoryData) => {
  const deliveryStatus = getDeliveryStatus(
    catalogItem,
    bopiwWarehouseEnabled,
    wioWarehouseEnabled,
    inventoryData
  );
  if (deliveryStatus === DeliveryStatus.ViaInstacart) {
    return {
      status: DeliveryStatus.ViaInstacart,
      showPriceMayVaryText: true
    };
  }
  if (!deliveryStatus) return null;
  return {
    status: deliveryStatus
  };
};
const getFsaEligibility = (...args) => getFsaEligibility$1(...args);
const getChdiEligibility = (...args) => getChdiEligibility$1(...args);
const getColorSwatchesData = (...args) => getColorSwatchesData$1(...args);
const getReplacementItemNumber = (item, cookieContext, opts) => {
  const { inWarehouseChannelBadgeData, hasSingleSku, locale } = opts || {};
  const isOnlinePrice = getIsOnlinePrice(item);
  const isWarehousePrice = getIsWarehousePrice(
    item,
    inWarehouseChannelBadgeData,
    hasSingleSku
  );
  const selectedWarehouse = getSelectedWarehouseCatalog(
    locale,
    cookieContext,
    {
      isOnlinePrice,
      isWarehousePrice
    }
  );
  const selectedReplacement = selectByWarehouse(
    item == null ? void 0 : item.replacement,
    selectedWarehouse
  );
  if (!selectedReplacement) return null;
  return (selectedReplacement == null ? void 0 : selectedReplacement.type) === REPLACEMENT_TYPE ? selectedReplacement == null ? void 0 : selectedReplacement.item : null;
};
const parseBatchedItemResponse = async (itemNumber, response) => {
  const batchedItemNumbers = itemNumber.split(",");
  const batchApiResponseData = await response.json();
  const parsedBatchData = batchedItemNumbers == null ? void 0 : batchedItemNumbers.map(
    (itemNumber2) => {
      var _a;
      const itemResponse = batchApiResponseData == null ? void 0 : batchApiResponseData.productData.find(
        (item) => item.id === itemNumber2
      );
      const inventoryItemNumbers = ((_a = itemResponse == null ? void 0 : itemResponse.childCatalogData) == null ? void 0 : _a.map((item) => item.id).map(Number)) || [];
      return {
        inventoryItemNumbers,
        productApiResponseData: { productData: [itemResponse] },
        itemNumber: itemNumber2
      };
    }
  );
  return parsedBatchData;
};
const getCompareProductButtonData = (...args) => getCompareProductButtonData$1(...args);
const getReviewRatingData = (...args) => getReviewRatingData$1(...args);
const getInWareHouseChannelBadgeData = (...args) => getInWareHouseChannelBadgeData$1(...args);
const getImageUrlPCP = (item) => getImageUrlPCP$1(item);
const getPillBadges = (...args) => getPillBadges$1(...args);
const getMemberOnlyData = (item, childData) => {
  var _a, _b;
  if (!childData || !((_a = childData.catalogData) == null ? void 0 : _a.length)) return false;
  const { dispPriceInCartOnly } = item;
  return (_b = childData == null ? void 0 : childData.catalogData) == null ? void 0 : _b.some((childItem) => {
    return childItem.isMembershipReqd && dispPriceInCartOnly === 1;
  });
};
const getPriceList = (childData, ecoFee, opts) => {
  if (!childData) return [];
  const isBDProduct = isBD();
  const parsedIncludeInPriceEcoFee = (ecoFee == null ? void 0 : ecoFee.includeInPrice) ? parseFloat(ecoFee.includeInPrice) || 0 : 0;
  const extractPrices = (priceOptions, price, displayPrice) => {
    if (price) {
      const parsedPrice = parseFloat(price.toString());
      if (!Number.isNaN(parsedPrice) && parsedPrice > 0) {
        const parsedPriceWithEcoFee = parsedPrice + parsedIncludeInPriceEcoFee;
        const totalDiscount = (displayPrice == null ? void 0 : displayPrice.aggregatedDiscountAmt) ? displayPrice == null ? void 0 : displayPrice.aggregatedDiscountAmt : 0;
        const finalPrice = parsedPriceWithEcoFee - totalDiscount;
        priceOptions.push(finalPrice);
      }
    }
  };
  const getMinPrice = (priceOptions) => {
    return priceOptions.length > 0 ? Math.min(...priceOptions) : void 0;
  };
  const data = childData.catalogData;
  if (!data) return [];
  const {
    isOnlinePrice = true,
    isWarehousePrice = false,
    cookieContext,
    locale
  } = opts || {};
  return data.map((item) => {
    const priceOptions = [];
    const { displayPrice: dp } = item;
    const selectedWarehouse = getSelectedWarehouseCatalog(
      locale,
      cookieContext,
      {
        isOnlinePrice,
        isWarehousePrice
      }
    );
    const displayPrice = selectByWarehouse(dp, selectedWarehouse);
    if (isBDProduct) {
      extractPrices(
        priceOptions,
        (displayPrice == null ? void 0 : displayPrice.onlinePrice) ?? "",
        displayPrice
      );
      extractPrices(
        priceOptions,
        (displayPrice == null ? void 0 : displayPrice.deliveredPrice) ?? "",
        displayPrice
      );
    } else {
      extractPrices(priceOptions, (displayPrice == null ? void 0 : displayPrice.onlinePrice) ?? "");
      extractPrices(priceOptions, (displayPrice == null ? void 0 : displayPrice.deliveredPrice) ?? "");
    }
    return getMinPrice(priceOptions);
  }).filter((value) => value !== void 0);
};
const getProductDeliveryBadgeData = (...args) => getProductDeliveryBadgeData$1(...args);
const getProductFeaturesData = (...args) => getProductFeaturesData$1(...args);
const getProductActions = (...args) => getProductActions$1(...args);
const getIsOnlinePrice = (item) => {
  const toLowerCaseProgramType = programTypeToLowercase(item);
  const { dispPriceInCartOnly } = item;
  const acceptedProgramTypes = [
    ProgramTypeVariants.LOCATION_CONTROLLED_INVENTORY,
    ProgramTypeVariants.TWO_DAY_DELIVERY,
    ProgramTypeVariants.SITE_CONTROLLED_INVENTORY,
    ProgramTypeVariants.STANDARD,
    ProgramTypeVariants.NATIONAL,
    ProgramTypeVariants.SAME_DAY_DELIVERY
  ];
  const programTypeCheck = isBD() ? true : acceptedProgramTypes.some(
    (type) => toLowerCaseProgramType == null ? void 0 : toLowerCaseProgramType.includes(type.toLowerCase())
  );
  return programTypeCheck && dispPriceInCartOnly !== 2;
};
const getIsWarehousePrice = (item, inWarehouseChannelBadgeData, hasSingleSku = true) => {
  if (!inWarehouseChannelBadgeData) return false;
  const toLowerCaseProgramTypeSet = new Set(
    programTypeToLowercase(item)
  );
  const programTypeCheckWarehouse = isBC() && PROGRAM_TYPES_PRICE_WAREHOUSE.some(
    (type) => toLowerCaseProgramTypeSet.has(type.toLocaleLowerCase())
  );
  if (!programTypeCheckWarehouse || !hasSingleSku) return false;
  return true;
};
const getDiscountsData = (item, cookieContext, opts) => {
  if (!item || !item.displayPrice || !cookieContext) return null;
  const { locale, inWarehouseChannelBadgeData, hasSingleSku } = opts || {};
  const isOnlinePrice = getIsOnlinePrice(item);
  const isWarehousePrice = getIsWarehousePrice(
    item,
    inWarehouseChannelBadgeData,
    hasSingleSku
  );
  const selectedWarehouse = getSelectedWarehouseCatalog(
    locale,
    cookieContext,
    {
      isOnlinePrice,
      isWarehousePrice
    }
  );
  const displayPrice = selectByWarehouse(
    item == null ? void 0 : item.displayPrice,
    selectedWarehouse
  );
  if (!displayPrice) return null;
  return {
    displayDiscount: isBD(),
    totalDiscount: displayPrice == null ? void 0 : displayPrice.aggregatedDiscountAmt
  };
};
const getPriceData = (item, hasSingleSku, cookieContext, childData, ecoFee, signedIn, isProductDetailsPage, opts) => {
  var _a, _b, _c, _d;
  const { wcMember } = cookieContext;
  if (!hasMembershipId(wcMember.value, signedIn, isProductDetailsPage) && getMemberOnlyData(
    item,
    Array.isArray(childData) ? childData[0] : childData
  ))
    return null;
  const { translationsConfig, inWarehouseChannelBadgeData, locale } = opts || {};
  const isOnlinePrice = getIsOnlinePrice(item);
  const isWarehousePrice = getIsWarehousePrice(
    item,
    inWarehouseChannelBadgeData,
    hasSingleSku
  );
  const priceList = getPriceList(
    Array.isArray(childData) ? childData[0] : childData,
    ecoFee,
    {
      isOnlinePrice,
      isWarehousePrice,
      cookieContext,
      locale
    }
  ) || [];
  if (!priceList.length) return null;
  const minSalePrice = Math.min(...priceList);
  const maxSalePrice = Math.max(...priceList);
  const fulfillmentTexts = translationsConfig ? getProductFullfillmentTexts(
    isOnlinePrice ? ProductFulfillmentCategories.ONLINE : ProductFulfillmentCategories.WAREHOUSE,
    translationsConfig
  ) : null;
  const priceData = {
    priceText: null,
    priceValue: minSalePrice,
    fulfillmentTexts
  };
  if (isOnlinePrice) {
    const hasPriceRangeAttr = ((_d = (_c = (_b = (_a = item == null ? void 0 : item.productAttributes) == null ? void 0 : _a[0]) == null ? void 0 : _b.object) == null ? void 0 : _c.find(
      (attr) => attr.key === ATTRIBUTE_HIDE_PRICE_RANGE_KEY
    )) == null ? void 0 : _d.value) === ATTRIBUTE_1_VALUE;
    if (!hasSingleSku) {
      if (hasPriceRangeAttr && minSalePrice < maxSalePrice) {
        priceData.priceText = "Starting at";
        return priceData;
      } else if (minSalePrice === maxSalePrice) {
        return priceData;
      } else if (minSalePrice != null && maxSalePrice != null) {
        priceData.priceValue = [minSalePrice, maxSalePrice];
        return priceData;
      }
    } else {
      return priceData;
    }
  } else if (!!inWarehouseChannelBadgeData) {
    const toLowerCaseProgramTypeSet = new Set(
      programTypeToLowercase(item)
    );
    const programTypeCheckWarehouse = isBC() ? true : PROGRAM_TYPES_PRICE_WAREHOUSE.some(
      (type) => toLowerCaseProgramTypeSet.has(type.toLocaleLowerCase())
    );
    if (!programTypeCheckWarehouse || !hasSingleSku) return null;
    return priceData;
  }
  return null;
};
const getAddToListButtonData = (item, productName, hasSingleSku, cookieContent, childData) => {
  var _a;
  const imageUrl = getImageUrlPCP(item);
  const price = getPriceData(item, hasSingleSku, cookieContent, childData);
  const { productClassType, isBuyable, productAttributes } = item;
  const isBundle = (_a = productAttributes == null ? void 0 : productAttributes[0]) == null ? void 0 : _a.object.some(
    (attr) => attr.key === ATTRIBUTE_BUNDLE
  );
  if (hasSingleSku && isBuyable && !PRODUCT_CLASS_TYPES.includes(productClassType || "") && !isBundle) {
    return {
      image: imageUrl,
      name: productName,
      price: price == null ? void 0 : price.priceValue
    };
  }
  return null;
};
export {
  getAddToListButtonData,
  getChdiEligibility,
  getColorSwatchesData,
  getCompareProductButtonData,
  getDeliveryChannelBadgeData,
  getDiscountsData,
  getFsaEligibility,
  getImageUrlPCP,
  getInWareHouseChannelBadgeData,
  getInWarehouseAvailabilityText,
  getMemberOnlyData,
  getPillBadges,
  getPriceData,
  getPriceList,
  getProductActions,
  getProductDeliveryBadgeData,
  getProductFeaturesData,
  getProgramTypeAvailability,
  getReplacementItemNumber,
  getReviewRatingData,
  isProgramTypeExists,
  parseBatchedItemResponse,
  programTypeToLowercase
};
